import { consola } from 'consola'
import { defineNuxtRouteMiddleware } from '#app'

// Logger
const logger = consola.withTag('yandex-auth-redirect')

/**
 * Middleware для обработки редиректа от Яндекс OAuth
 * 
 * ✅ Автоматически закрывает окно/вкладку с параметром ?sessionId=...
 * ✅ Работает на всех платформах (Chrome, Firefox, Safari)
 * ✅ Fallback UI для случаев когда window.close() не работает
 * 
 * Логика:
 * 1. Пользователь авторизуется через Яндекс в новой вкладке
 * 2. Яндекс делает редирект на /?sessionId=dbf75df5-...
 * 3. Этот middleware обнаруживает sessionId в query
 * 4. Автоматически закрывает вкладку
 * 5. Исходная вкладка получает completed через polling
 */
export default defineNuxtRouteMiddleware((to, _from) => {
  // Работает только на клиенте
  if (!process.client) return

  // Проверяем наличие sessionId в query параметрах
  const sessionId = to.query.sessionId as string | undefined

  if (sessionId) {
    logger.info('🔍 Обнаружен редирект от Яндекс OAuth с sessionId:', sessionId)
    
    // Пытаемся закрыть окно сразу
    // Работает если окно было открыто через window.open()
    const closeAttempt1 = window.close()
    
    logger.info('📍 Первая попытка закрыть окно:', closeAttempt1)

    // Даем браузеру время на обработку
    setTimeout(() => {
      // Проверяем, закрылось ли окно
      if (window.closed) {
        logger.success('✅ Окно успешно закрыто автоматически')
      } else {
        logger.warn('⚠️ Окно не закрылось автоматически (возможно Safari), показываем сообщение')
        
        // Показываем уведомление пользователю
        if (typeof document !== 'undefined') {
          // Создаем красивое оверлей с сообщением
          const overlay = document.createElement('div')
          overlay.style.cssText = `
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 999999;
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          `
          
          const message = document.createElement('div')
          message.style.cssText = `
            background: white;
            padding: 40px;
            border-radius: 16px;
            text-align: center;
            max-width: 400px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          `
          
          message.innerHTML = `
            <div style="font-size: 48px; margin-bottom: 20px;">✅</div>
            <h2 style="margin: 0 0 16px 0; font-size: 24px; font-weight: 600; color: #1a1a1a;">
              Авторизация успешна!
            </h2>
            <p style="margin: 0 0 24px 0; font-size: 16px; color: #666; line-height: 1.5;">
              Вы можете закрыть эту вкладку и вернуться к предыдущей.
            </p>
            <button 
              onclick="window.close()" 
              style="
                background: #000;
                color: white;
                border: none;
                padding: 12px 32px;
                border-radius: 8px;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.2s;
              "
              onmouseover="this.style.background='#333'"
              onmouseout="this.style.background='#000'"
            >
              Закрыть вкладку
            </button>
            <p style="margin: 16px 0 0 0; font-size: 12px; color: #999;">
              Если кнопка не работает, закройте вкладку вручную
            </p>
          `
          
          overlay.append(message)
          document.body.append(overlay)
          
          logger.success('✅ Показано сообщение о закрытии вкладки')
        }
      }
    }, 500)

    // Останавливаем дальнейшую навигацию
    // Страница должна остаться на текущем URL и не загружать компоненты
    return abortNavigation()
  }
})







